import flatten from 'lodash-es/flatten';
import uniq from 'lodash-es/uniq';
import { userGroupScopes as getUserGroupScopes } from '@simplyanvil/cl-types';

export interface UserOrganisationLike {
  id?: string;
  orgId?: string;
  access?: {
    groups?: string[];
    scopes?: string[];
  };
}

// The user's organisation memberships in the shape the app reads them: a stable id/orgId pair
// and the scopes a membership's groups imply merged into its explicit scopes. The groups are
// kept as well — dropping them left `getOrgGroups()` empty, which hid the billing tab from the
// very owners it is meant for, because an owner is identified by the group, not by a scope.
export const normalizeUserOrganisations = <T extends UserOrganisationLike>(organisations: T[]): T[] =>
  organisations.map((org) => {
    const groups = org?.access?.groups ?? [];
    const groupedScopes = flatten(groups.map((group) => getUserGroupScopes[group])).filter(Boolean);
    return {
      ...org,
      id: org.id || org.orgId,
      orgId: org.id || org.orgId,
      access: {
        ...org.access,
        groups,
        scopes: uniq([...(org?.access?.scopes ?? []), ...groupedScopes])
      }
    };
  });
